
<template>
  <div>
    <div class="header">
    	<div>
    		<img src="../../../../static/image/img2.png" class="logo1"/>
    		<img src="../../../../static/image/logo1.png" class="logo1"/>
    	</div>
    	<div >
    	  <span id="1" :class="isSel==1?'selnavspan':'navspan'" @click="home()">首页</span>
    	  <span id="2" :class="isSel==2?'selnavspan':'navspan'" @click="qyjs()">企业介绍</span>
    	  <span id="3" :class="isSel==3?'selnavspan':'navspan'" @click="gywm()">关于我们</span>
    	  <span id="4" :class="isSel==4?'selnavspan':'navspan'" @click="zshz()">招商合作</span>
    	  <span id="5" :class="isSel==5?'selnavspan':'navspan'" @click="sjrz()">商家入驻</span>
    	  <span id="6" :class="isSel==6?'selnavspan':'navspan'" @click="ywms()">业务模式</span>
    	</div>
      <div>
        <span onclick="window.location.href='http://www.lnkading.com/home/login/login.html'">商家登录</span>
        <span @click="yhindex()" style="margin-left: 20px;">用户商城</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'topMenu',
    props: ['Sel'],
    data() {
      return {
        isSel:this.Sel
      }
    },
    //初始化
    created(){
      console.log("组件初始化")
    },
    methods:{
      //首页
      home(){
        this.$router.push("/")
      },
      //企业介绍
      qyjs(){
        if(this.isSel==2){
          return
        }
        this.$router.push("/qyjs")
      },
      //关于我们
      gywm(){
        if(this.isSel==3){
          return
        }
        this.$router.push("/gywm")
      },
      //招商合作
      zshz(){
        if(this.isSel==4){
          return
        }
        this.$router.push("/zshz")
      },
      //商家入驻
      sjrz(){
        if(this.isSel==5){
          return
        }
        this.$router.push("/sjrz")
      },
      //业务模式
      ywms(){
        if(this.isSel==6){
          return
        }
        this.$router.push("/ywms")
      },
      //商城首页
      yhindex(){
        this.$router.push("/index")
      }
    }
  }
</script>

<style>
  .header {
  	width: 100%;
  	height:60px;
  	box-sizing: border-box;
  	display: flex;
  	align-items: center;
  	justify-content: space-around;
  }
  .logo1 {
  	height:40px;
  }
  .navspan {
  	display: inline-block;
  	width: 100px;
  	text-align: center;
  	font-size: 16px;
  	line-height:50px;
  	color: #111;
  	font-weight:bold;
  }
  .selnavspan {
  	display: inline-block;
  	width: 100px;
  	text-align: center;
  	font-weight:bold;
    color: #FD8723;
    border-bottom:3px solid #FD8723;
    font-size: 20px;
    line-height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/components/official/components/topMenu.vue